export const EMPLOYMENT_TYPES = [

    {
        value:"self_employed",
        label:"Self Employed"
    },

    {
        value:"salaried",
        label:"Salaried"
    },

    {
        value:"business",
        label:"Business"
    }

];